import { render, staticRenderFns } from "./PaymentIndicator.vue?vue&type=template&id=203be3bc"
import script from "./PaymentIndicator.vue?vue&type=script&lang=js"
export * from "./PaymentIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports